require('../modules/es6.parse-int');
module.exports = require('../modules/_core').parseInt;



// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/node_modules/core-js/library/fn/parse-int.js